import React from 'react';
import { Typography, Avatar } from '@material-ui/core';
import styled from 'styled-components';
import { IconSize } from '../../../../../../lib';
import { defaultMuiTheme } from '../../../../../../styles/MaterialTheme';
import { Collaborators } from '../../../../../Collections';
import { FlatChip } from '../../../../../DataDisplay';
import SkillImage from '../../../../../Image/components/SkillImage';
import ViewerErrorBoundary from '../../ViewerConclusion/ViewerErrorBoundary';
import { ViewerHeaderAttributesContainer, ViewerHeaderImageContainer, StyledTypography } from '../ViewerHeader.styles';
const SkillInfoContainer = styled.div `
    display: flex;
    align-items: center;
    box-sizing: content-box;
    margin-bottom: 1.5rem;
`;
const SkillViewerHeaderAttributesContainer = styled(ViewerHeaderAttributesContainer) `
    align-items: flex-start;
`;
const SkillHeaderWrapper = styled.div `
    padding: 12px 12px 0 12px;
    ${defaultMuiTheme.breakpoints.up('sm')} {
        padding: 16px 16px 0 16px;
    }
`;
const StyledAvatar = styled(Avatar) `
    width: ${IconSize.Medium};
    height: ${IconSize.Medium};
`;
export const SKILL_TYPE_TEXT = 'Skill';
const SkillViewerHeader = ({ ownerAvatarSrc, ownerName, uncroppedImage, title, subtitle, collaborators, createdAt, estimatedSecondsToConsume, parentTitle }) => {
    var _a;
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(SkillHeaderWrapper, null,
            React.createElement(SkillInfoContainer, null,
                React.createElement(ViewerHeaderImageContainer, null,
                    React.createElement(SkillImage.Large, { image: uncroppedImage }))),
            React.createElement(SkillViewerHeaderAttributesContainer, null,
                React.createElement(FlatChip.UppercaseTertiary, { avatar: React.createElement(StyledAvatar, { src: ownerAvatarSrc, alt: "Content owner logo" }, (_a = ownerName === null || ownerName === void 0 ? void 0 : ownerName.charAt(0)) === null || _a === void 0 ? void 0 : _a.toUpperCase()), label: ownerName }),
                React.createElement(StyledTypography, { variant: "h4" }, title),
                subtitle ? React.createElement(Typography, { variant: "subtitle1" }, subtitle) : null,
                React.createElement(Collaborators, { collaborators: collaborators, createdAt: createdAt, estimatedSecondsToConsume: estimatedSecondsToConsume, parentTitle: parentTitle })))));
};
export default SkillViewerHeader;
//# sourceMappingURL=index.js.map